<template>
  <div id="app-inner">
    <site-header />
    <div class="c-site-main">
      <transition name="fade">
        <router-view :key="$route.path"></router-view>
      </transition>
    </div>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    SiteHeader: SiteHeader,
    SiteFooter: SiteFooter
  },
  metaInfo: {
    titleTemplate: '%s | The Chatham Island Taiko Trust',
    meta: [{
      name: 'description',
      content: 'Established in 1998, the Chatham Islands Taiko Trust was originally created to conserve the endangered taiko as an integral part of the Chatham Island landscape.'
    }, {
      name: 'og:image',
      content: 'https://www.taikotrust.org.nz/uploads/images/_hero/Home.jpg'
    }]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/App.vue